import ListItem from '@mui/material/ListItem'
import withStyles from '@mui/styles/withStyles'

const CustomListItem = withStyles(() => ({}))(ListItem)

export default CustomListItem
